// extracted by mini-css-extract-plugin
export default {"WarningsCell":"externalLinks_WarningsCell__UnHz7","NotesIconBox":"externalLinks_NotesIconBox__bMJlH"};